// our stores tab js.
(function() {
    'use strict';
    document.addEventListener('DOMContentLoaded', function() {
        const tabButtons = document.querySelectorAll('.our-stores__tab-btn');
        const panels = document.querySelectorAll('.our-stores__panel');
        tabButtons.forEach(button => {
            button.addEventListener('click', function() {
                const targetTabId = this.getAttribute('data-tab') + '-panel';
                const targetPanel = document.getElementById(targetTabId);
                if (this.classList.contains('our-stores__tab-btn--active') || !targetPanel) {
                    return;
                }
                // Update tab buttons active state
                tabButtons.forEach(btn => {
                    btn.classList.remove('our-stores__tab-btn--active');
                    btn.setAttribute('aria-selected', 'false');
                });
                this.classList.add('our-stores__tab-btn--active');
                this.setAttribute('aria-selected', 'true');

                // Fade out current active panel
                const currentPanel = document.querySelector('.our-stores__panel--active');
                if (currentPanel) {
                    currentPanel.classList.add('our-stores__panel--fading');
                    setTimeout(() => {
                        currentPanel.classList.remove('our-stores__panel--active', 'our-stores__panel--fading');
                        // Show and fade in new panel
                        targetPanel.classList.add('our-stores__panel--active');
                        // resize slider
                        const slider = document.querySelector('.t4s-carousel[data-flickityt4s]');
                        if (slider) {
                          //alert("resize slider");
                          window.dispatchEvent(new Event('resize'));
                        }
                    }, 250);
                    } else {
                        targetPanel.classList.add('our-stores__panel--active');
                    }
                });
        });

    });
})();

// coitonic faq
document.addEventListener('DOMContentLoaded', () => {
  const faqItems = document.querySelectorAll('.coitonic-faq__item');
  faqItems.forEach((item) => {
    const questionBtn = item.querySelector('.coitonic-faq__question');
    const answer = item.querySelector('.coitonic-faq__answer');
    questionBtn.addEventListener('click', () => {
      const isActive = item.classList.contains('coitonic-faq__item--active');
      // Close all active items for accordion behavior (optional: remove loop if you want multiple open at once)
      faqItems.forEach((otherItem) => {
        otherItem.classList.remove('coitonic-faq__item--active');
        const otherBtn = otherItem.querySelector('.coitonic-faq__question');
        const otherAnswer = otherItem.querySelector('.coitonic-faq__answer');
        
        if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        if (otherAnswer) otherAnswer.style.maxHeight = null;
      });
      // Toggle current item state
      if (!isActive) {
        item.classList.add('coitonic-faq__item--active');
        questionBtn.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
});

// load numbers on load
document.addEventListener('DOMContentLoaded', () => {
  const statNumbers = document.querySelectorAll('.visit-nearest__stat-number');
  const animationDuration = 1800; // Total duration in ms

  const animateCounters = () => {
    statNumbers.forEach((stat) => {
      const startValue = parseInt(stat.getAttribute('data-start'), 10) || 0;
      const targetValue = parseInt(stat.getAttribute('data-target'), 10);
      const suffix = stat.getAttribute('data-suffix') || '';

      let startTime = null;

      const step = (currentTime) => {
        if (!startTime) startTime = currentTime;
        const progress = Math.min((currentTime - startTime) / animationDuration, 1);
        
        // Easing function for smooth slowdown effect at the end
        const easeOutQuad = 1 - (1 - progress) * (1 - progress);
        const currentValue = Math.floor(startValue + (targetValue - startValue) * easeOutQuad);

        stat.textContent = `${currentValue}${suffix}`;

        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          stat.textContent = `${targetValue}${suffix}`;
        }
      };

      window.requestAnimationFrame(step);
    });
  };

  // Trigger animation when section comes into view
  const section = document.querySelector('.visit-nearest');
  if ('IntersectionObserver' in window && section) {
    let animated = false;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !animated) {
          animated = true;
          animateCounters();
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    observer.observe(section);
  } else {
    // Fallback if IntersectionObserver is not supported
    animateCounters();
  }
});

// marquee js
document.addEventListener('DOMContentLoaded', () => {
  // Use querySelectorAll to target ALL elements with this class name
  const grids = document.querySelectorAll('.store-experience__grid');
  grids.forEach((grid) => {
    // Collect original children
    const originalCards = Array.from(grid.children);
    if (originalCards.length === 0) return;

    // Create a track container for this specific grid
    const track = document.createElement('div');
    track.classList.add('store-experience__marquee-track');

    // Move original items inside the track
    originalCards.forEach((card) => track.appendChild(card));

    // Clone items for a seamless loop
    originalCards.forEach((card) => {
      const clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    // Clear and append track to current grid
    grid.innerHTML = '';
    grid.appendChild(track);
    grid.classList.add('store-experience__grid--marquee');
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const timeline = document.querySelector('.store-journey__timeline');
  const lineFill = id = document.getElementById('journeyLineFill');
  const items = document.querySelectorAll('.store-journey__item');

  if (!timeline || !lineFill) return;

  const updateTimelineProgress = () => {
    const timelineRect = timeline.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate how far the top of the timeline is from middle of viewport
    const timelineTop = timelineRect.top;
    const timelineHeight = timelineRect.height;
    
    // Start filling when the top reaches 60% down the screen
    const startPoint = windowHeight * 0.6; 
    
    let progress = (startPoint - timelineTop) / timelineHeight;
    
    // Clamp progress between 0% and 100%
    progress = Math.max(0, Math.min(1, progress));
    
    // Update line fill height percentage
    lineFill.style.height = `${progress * 100}%`;

    // Highlight timeline nodes step by step when reached
    items.forEach((item) => {
      const divisor = window.innerWidth <= 767 ? 14 : 2;
      const itemRect = item.getBoundingClientRect();
      const itemMiddle = itemRect.top + itemRect.height / divisor;

      if (itemMiddle <= startPoint) {
        item.classList.add('is-active');
      } else {
        item.classList.remove('is-active');
      }
    });
  };

  // Run on scroll and resize
  window.addEventListener('scroll', updateTimelineProgress, { passive: true });
  window.addEventListener('resize', updateTimelineProgress);

  // Initial call on page load
  updateTimelineProgress();
});


// popup validation 
  document.addEventListener('DOMContentLoaded', function () {
    const trigger = document.getElementById('newsletterpopup');
    const popup = document.getElementById('NewsletterPopup');
    const closeButtons = popup
      ? popup.querySelectorAll('[data-newsletter-close]')
      : [];

    const form = document.getElementById('NewsletterPopupForm');
    const emailInput = document.getElementById('NewsletterPopupEmail');
    const errorMessage = document.getElementById('NewsletterPopupError');

    if (!trigger || !popup) return;

    function openNewsletterPopup() {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');

      document.body.style.overflow = 'hidden';

      setTimeout(function () {
        if (emailInput) {
          emailInput.focus();
        }
      }, 300);
    }

    function closeNewsletterPopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');

      document.body.style.overflow = '';

      if (errorMessage) {
        errorMessage.hidden = true;
        errorMessage.textContent = '';
      }
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openNewsletterPopup();
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        closeNewsletterPopup();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (
        event.key === 'Escape' &&
        popup.classList.contains('is-open')
      ) {
        closeNewsletterPopup();
      }
    });

    if (form && emailInput && errorMessage) {
      form.addEventListener('submit', function (event) {
        const email = emailInput.value.trim();
        errorMessage.hidden = true;
        errorMessage.textContent = '';
        if (!email) {
          event.preventDefault();
          errorMessage.textContent = 'Please enter your email address.';
          errorMessage.hidden = false;
          emailInput.focus();
          return;
        }
        const emailPattern =
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailPattern.test(email)) {
          event.preventDefault();
          errorMessage.textContent =
            'Please enter a valid email address.';
          errorMessage.hidden = false;
          emailInput.focus();
        }
      });
    }
  });
// experience store image popup js. 
// document.addEventListener('DOMContentLoaded', () => {
//   const cards = document.querySelectorAll('.store-experience__card');
//   const lightbox = document.getElementById('storeLightbox');
//   const lightboxImg = document.getElementById('lightboxImage');
//   const lightboxClose = document.getElementById('lightboxClose');
//   const lightboxOverlay = document.getElementById('lightboxOverlay');

//   // Open Lightbox
//   const openLightbox = (imageSrc, imageAlt) => {
//     lightboxImg.src = imageSrc;
//     lightboxImg.alt = imageAlt || 'Enlarged Store View';
//     lightbox.classList.add('is-open');
//     lightbox.setAttribute('aria-hidden', 'false');
//     document.body.style.overflow = 'hidden'; // Prevent background page scrolling
//   };

//   // Close Lightbox
//   const closeLightbox = () => {
//     lightbox.classList.remove('is-open');
//     lightbox.setAttribute('aria-hidden', 'true');
//     document.body.style.overflow = ''; // Restore background scrolling
//     setTimeout(() => {
//       lightboxImg.src = ''; // Clear source after fade animation completes
//     }, 300);
//   };

//   // Attach click listener to every store experience card
//   cards.forEach((card) => {
//     card.addEventListener('click', () => {
//       const img = card.querySelector('.store-experience__image');
//       if (img) {
//         openLightbox(img.src, img.alt);
//       }
//     });
//   });

//   // Close events
//   if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
//   if (lightboxOverlay) lightboxOverlay.addEventListener('click', closeLightbox);

//   // Close on Escape key press
//   document.addEventListener('keydown', (e) => {
//     if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
//       closeLightbox();
//     }
//   });
// });